export const config = {
    std: {
        api: 'https://faninfohub-dev.fifa.org/api',
        field: {
            tournaments: {
                name: 'tournament',
                id: 'tournamentId'
            },
            roles: {
                name: 'roles',
                id: 'roleIds'
            },
            teams: {
                name: 'teams',
                id: 'teamIds'
            }
        }
    },
    uat: {
        api: 'https://faninfohub-dev.fifa.org/api',
        field: {
            tournaments: {
                name: 'tournament',
                id: 'tournamentId'
            },
            roles: {
                name: 'roles',
                id: 'roleIds'
            },
            teams: {
                name: 'teams',
                id: 'teamIds'
            }
        }
    },
    prod: {
        api: 'https://faninfohub.fifa.org/api',
        field: {
            tournaments: {
                name: 'tournament',
                id: 'tournamentId'
            },
            roles: {
                name: 'roles',
                id: 'roleIds'
            },
            teams: {
                name: 'teams',
                id: 'teamIds'
            }
        }
    }
}